<template>
  <div>
    <productBanner />
    <div class="content">
      <div class="ins">
        <div class="title">食品安全监管服务平台</div>
        <div class="desc">发挥权威行业数据优势，融合市场监督管理局、企业商户、第三方的食品相关数据，实现在线智慧监管、食安追溯、培训认证等服务</div>
        <div>
          <p class="service">服务</p>
          <p class="fun">食品安全监管服务平台有以下功能模块：</p>
          <img src="./images/img.png" alt="">
        </div>
      </div>
      <div class="img-container">
        <img src="~assets/images/products/product4.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import productBanner from 'components/product-banner'
export default {
  components: {
    productBanner
  }
}
</script>

<style lang="stylus" scoped>
.content
  padding 80px 9%
  display flex
  .ins
    flex 1
    display flex
    flex-direction column
    .title
      line-height 70px
      color #0160B7
      font-size 30px
    .desc
      line-height 1.5
      font-size 14px
      color #333333
    img
      width 100%
      margin-top 10px
  .service
    margin-top 8%
    font-size 18px
    color #333333
    margin-bottom 10px
  .fun
    color #666666
    font-size 14px
  .list
    display flex
    justify-content space-between
    margin-top 22px
    &.list2
      justify-content start
      .item
        margin-right 1.5%
    .item
      line-height 58px
      width 32%
      font-size 14px
      text-align center
      border 1px dashed #287BFF
      background rgba(240,246,255,1)
  .img-container
    flex 1
    img
      width 95%
      margin-left 5%
@media screen and (max-width: 1500px)
  .service
    margin-top 3% !important
</style>



// WEBPACK FOOTER //
// src/pages/spaq/spaq.vue